import { Dispatch } from 'redux';
import { batch } from 'react-redux';
import { resetValue } from '../entity/actions';
import { EntityActionType } from '../entity/types';

const resetAssignmentAttempt = () => async (dispatch: Dispatch): Promise<void> =>
  batch(() => {
    dispatch(resetValue('assignmentAttempt'));
    dispatch(resetValue('assignmentAttemptMessages'));
  });

const resetAssignmentDetail = () => async (
  dispatch: Dispatch
): Promise<{ type: EntityActionType; key: string }> => dispatch(resetValue('assignmentDetail'));

export { resetAssignmentAttempt, resetAssignmentDetail };
